<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
function waitForElement(selector, callback) {
    const intervalId = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(intervalId);
            callback(element);
        }
    }, 100); // Intervalo de verificación en milisegundos
}

// Uso:
waitForElement('.tmenu-watermark', (element) => {
    // Hacer algo con el elemento una vez que esté disponible
    element.style.display = 'none'; // Ocultar el elemento
});

  /*document.addEventListener("DOMContentLoaded", function() {
            // Selecciona el botón con la clase específica
            var button = document.querySelector('.shopify-payment-button__button.shopify-payment-button__button--unbranded');
            
            // Verifica si el botón existe y cambia el texto
            if (button) {
                button.textContent = "Paga ahora";
            }
        });
 document.addEventListener("DOMContentLoaded", function() {
            // Selecciona el label con la clase específica
            var label = document.querySelector('.global-checkbox--label.form-label--checkbox[for="product_conditions_9476505600278"]');
            
            // Verifica si el label existe y cambia el texto
            if (label) {
                label.textContent = "Acepto los términos";
            }
        });*/




<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
